import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Market } from '@app/model/payment-request/payment-request.dto';
import { LoggingService } from '@app/service/logging-service/logging.service';
import {
  AtRoute,
  DeRoute,
  NoRoute,
  FiRoute,
  routeNames,
} from '@assets/val/route-constants';

@Component({
  selector: 'navigation-catcher',
  templateUrl: './navigation-catcher.component.html',
  styleUrls: ['./navigation-catcher.component.css'],
})
export class NavigationCatcherComponent implements OnInit {
  constructor(private loggingService: LoggingService, private router: Router) {}

  ngOnInit(): void {
    const market = localStorage.getItem('zco_market');
    let route: string;

    switch (market) {
      case Market.AT:
        route = AtRoute.HOME;
        break;
      case Market.DE:
        route = DeRoute.HOME;
        break;
      case Market.FI:
        route = FiRoute.HOME;
        break;
      case Market.SE:
        route = routeNames.HOME;
        break;
      case Market.NO:
        route = NoRoute.HOME;
        break;
      default:
        route = routeNames.ERROR;
        break;
    }

    this.loggingService.reportCrash(
      'Landed in navigation error catcher!',
      'Rerouting to: /' + route
    );

    this.router.navigate([`/${route}`], {
      queryParamsHandling: 'preserve',
    });
  }
}
